import React, { useState } from 'react';

interface SearchBarProps {
  onSearch: (query: string) => void;
  isLoading?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({ onSearch, isLoading }) => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(query);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-4xl mx-auto">
      <div className="relative flex items-center bg-white rounded-full shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
        <div className="pl-6 pr-3 text-gray-400">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>

        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar documentos PQR..."
          className="flex-1 py-4 px-2 text-base focus:outline-none placeholder:text-gray-300"
          disabled={isLoading}
        />

        <button
          type="submit"
          disabled={isLoading}
          className="mr-2 shrink-0 p-2.5 sm:px-6 sm:py-2 bg-[#0943B5] text-white text-sm font-medium rounded-full hover:bg-[#072d8a] disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
        >
          <svg className="w-5 h-5 sm:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <span className="hidden sm:inline">
            {isLoading ? 'Buscando...' : 'Buscar'}
          </span>
        </button>
      </div>
    </form>
  );
};
